import { isMobile } from './devices';

export const concatPath = (path: string[]) => '/' + path.join('/');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildParams = (params?: Record<string, any>) => {
  if (!params) return '';
  if (Object.keys(params).length === 0) return '';
  const builded = Object.keys(params)
    .filter((key) => params[key] !== undefined)
    .map((key) => {
      if (key === 'extra_filters') {
        let objectKey = '';
        Object.keys(params[key]).forEach((k) => {
          const val = params[key][k];
          if (val) {
            objectKey += `extra_filters.${k}=${val}`;
          }
        });

        return objectKey;
      }
      return `${key}=${params[key]}`;
    })
    .join('&');
  if (!builded) return '';
  return '?' + builded;
};

export const getOrigin = () => {
  return window.location.origin;
};

export const pageSizeKey = 'pageSize';
export const pageKey = 'page';

export const defaultPage = '1';
export const defaultPageSize = '10';

export const overlayKey = 'overlayId';
export const viewStyleKey = 'viewStyle';
export const defaultViewStyle = isMobile() ? 'card' : 'table';

export const withArchiveKey = 'withArchive';

// @ts-ignore
export const appVersion = __APP_VERSION__;
export const swPath = '/manager/sw.js';
